import React, { useState, useCallback, useEffect, useRef } from "react";
import "../../styles/desktop/main.css";
import Menu from "../menu/menu";
import TextMain from "../Texto Principal/textoMain";
import Eventos from "../events/eventos";
import background from "../../assets/img/background.png";

import ChatBot from "../Plus/ChatBot/chatbot";
import PLUS from "../Plus/plus";
import Dispositivos from "../Plus/Dispositivos/dispositivo";
import Gestao from "../Gestao/gestao";
import Notificacao from "../Notificacao/notificacao";
import Monitoramento from "../Monitoramento/monitoramento";

// Hooks
import useEventos from "../../hooks/useEventos";
// import useMonitoramento from "../../hooks/useMonitoramento";

const Main = () => {
  /* ─────────────────────────── State ─────────────────────────── */
  const [paginaAtual, setPaginaAtual] = useState("PLUS");
  const [filtro, setFiltro] = useState("Todos");
  const [popupEvent, setPopupEvent] = useState(null);          // ← novo

  /* ─────────────────────────── Dados ─────────────────────────── */
  const { eventos, chamados, loading: eventosLoading, carregarEventos } = useEventos();

  /*
  const {
    cieData,
    loading: monitoramentoLoading,
    fetchCieData,
    getDeviceStatus,
    formatDateTime,
    getActiveAlerts,
    getDeviceSeverity
  } = useMonitoramento();
  */

  /* ───── Auto-switch p/ Monitoramento + evento escolhido ───── */
/*
  const prevAlertCount = useRef(0);
  useEffect(() => {
    const activeAlerts = getActiveAlerts();
    const alertCount   = activeAlerts.length;

    if (alertCount > 0 && prevAlertCount.current === 0 && paginaAtual !== "Monitoramento") {
       //prioriza evento FIRE, senão pega o primeiro da lista 
      const eventForPopup =
        activeAlerts.find(a => a.severity === "FIRE") ?? activeAlerts[0];

      setPopupEvent(eventForPopup);           // ← será mostrado no popup
      setPaginaAtual("Monitoramento");
    }
    prevAlertCount.current = alertCount;
  }, [cieData, paginaAtual, getActiveAlerts]);
*/
  /* ─────────────── Navegação manual (menu) ─────────────── */
  const trocarPagina = useCallback((pagina) => {
    if (pagina === "history") setFiltro("Todos");
    setPaginaAtual(pagina);
  }, []);

  /* ─────────────── Renderizador de páginas ─────────────── */
  const renderPageContent = () => {
    switch (paginaAtual) {
      case "Gestao":
        return <Gestao />;
      case "Chatbot":
        return <ChatBot />;
      case "history":
        return (
          <Eventos
            filtro={filtro}
            eventos={eventos}
            loading={eventosLoading}
            atualizarLista={carregarEventos}
            chamados={chamados}
          />
        );
      case "PLUS":
        return <PLUS />;
      case "Dispositivos":
        return <Dispositivos />;
      case "Monitoramento":
        return (
          <Monitoramento
          /*
            cieData={cieData}
            loading={monitoramentoLoading}
            fetchCieData={fetchCieData}
            getDeviceStatus={getDeviceStatus}
            formatDateTime={formatDateTime}
            getActiveAlerts={getActiveAlerts}
            getDeviceSeverity={getDeviceSeverity}
            initialEvent={popupEvent}
          */
          />
        );
      default:
        return <PLUS />;
    }
  };

  /* ─────────────────────────── JSX ─────────────────────────── */
  return (
    <div id="divMain">
      <Menu
        trocarPagina={trocarPagina}
        paginaAtual={paginaAtual}
        monitoramentoData={{
          /*
          devices: cieData.devices,
          hasAlert: getActiveAlerts().length > 0,
          alertCount: getActiveAlerts().length,
          activeAlerts: getActiveAlerts()
          */
        }}
      />

        {paginaAtual === "Gestao" ? (
          <Gestao />
        ) : (
          <div id="content-Central">{renderPageContent()}</div>
        )}

      {/*<Notificacao
        trocarPagina={trocarPagina}
        setFiltro={setFiltro}
        eventos={eventos}
      />*/}
    </div>
  );
};

export default Main;
